import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../utils/store";

const AuthGuard = () => {
    const { userLogin } = useSelector((state: RootState) => state.auth);
    
    return userLogin ? <Navigate to="/" replace /> : <Outlet />;
};

export default AuthGuard;
